import React from 'react';
import './Broadcast_main.css'
import Popup from './Popup/Popup.jsx'
import i18n, { t } from "i18next";
import { withTranslation } from 'react-i18next'
import { useTranslation } from "react-i18next";

export default class Broadcast extends React.Component {
    constructor(props) {
        super(props);
    }
    
    render() {
        return (
            <div className='broadcast_wrap'>
                <div className="container broadcast" id='broadcast'>
                    <div className='broadcast_content_block-wrap'>
                        <div className="broadcast_content_block">
                            <p className="broadcast_title">{t("broadcast.item1.title")}</p>
                            <div className="broadcast_content">
                                <iframe className="broadcast_video" width="100%" height="500px" src="https://www.youtube.com/embed/GLmaPu5xc8U" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </div>
                        </div>
                        <div className="broadcast_content_block">
                            <p className="broadcast_title">{t("broadcast.item2.title")}</p>
                            <div className="broadcast_content">
                                <iframe className="broadcast_video" width="100%" height="500px" src="https://www.youtube.com/embed/u_xhY4COydQ" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </div>
                        </div>
                        <div className="broadcast_content_block">
                            <p className="broadcast_title">{t("broadcast.item3.title")}</p>
                            <div className="broadcast_content">
                                <iframe className="broadcast_video" width="100%" height="500px" src="https://www.youtube.com/embed/XuxfA5fL4aw" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}